// 存放所有的侧边菜单栏配置
export default [
  {
    key: 'equipment',
    path: '/page/equipment',
    name: '设备',
    icon: 'database',
    sub: [
      {
        path: '/page/equipment/sendsample',
        name: '试试如意派样设备',
        key: 'sendsample',
      },
      {
        path: '/page/equipment/retailequipment',
        name: '零售设备',
        key: 'retailequipment',
      },
    ],
  },
  {
    key: 'tenant',
    path: '/page/tenant/tenant',
    name: '商户',
    icon: 'contacts',
  },
  {
    key: 'business',
    path: '/page/business',
    name: '运营商管理',
    icon: 'contacts',
    sub: [
      {
        path: '/page/business/business',
        name: '运营商管理',
        key: 'business',
      },
      {
        path: '/page/business/split',
        name: '分账管理',
        key: 'split',
      },
      {
        path: '/page/business/evaluate',
        name: '评价管理',
        key: 'evaluate',
      },
    ],
  },
  {
    key: 'brand',
    path: '/page/brand',
    name: '品牌商管理',
    icon: 'contacts',
  },
  {
    key: 'operating',
    path: '/page/operating',
    name: '试试如意运营',
    icon: 'user',
    sub: [
      {
        path: '/page/operating/accountingrules',
        name: '计费规则',
        key: 'accountingrules',
      },
      {
        path: '/page/operating/sendearnings',
        name: '派样收益',
        key: 'sendearnings',
      },
      {
        path: '/page/operating/evaluation',
        name: '测评管理',
        key: 'evaluation',
      },
    ],
  },
  {
    key: 'capitalaccount',
    path: '/page/capitalaccount',
    name: '资金账户管理',
    icon: 'account-book',
    sub: [
      {
        path: '/page/capitalaccount/earningsaccount',
        name: '收益账户',
        key: 'earningsaccount',
      },
      // {
      //   path: "/page/capitalaccount/businessaccount",
      //   name: "商户账户",
      //   key: "businessaccount",
      // },
    ],
  },
  {
    key: 'earnings',
    path: '/page/earnings/earnings',
    name: '收益',
    icon: 'pay-circle',
  },
  {
    key: 'employee',
    path: '/page/employee',
    name: '人员',
    icon: 'user',
    sub: [
      {
        path: '/page/employee/installemployee',
        name: '安装人员',
        key: 'InstallEmployee',
      },
      {
        path: '/page/employee/systememployee',
        name: '系统人员',
        key: 'SystemEmployee',
      },
    ],
  },
  {
    key: 'dataanalysis',
    path: '/page/dataanalysis',
    name: '数据统计',
    icon: 'bar-chart',
    sub: [
      {
        key: 'dataanalysis',
        path: '/page/dataanalysis/dataanalysis',
        name: '数据分析',
      },
      {
        key: 'takeOutOrderRecord',
        path: '/page/dataanalysis/takeOutOrderRecord',
        name: '外卖订单记录',
      },
      {
        key: 'refundRecord',
        path: '/page/dataanalysis/refundRecord',
        name: '退款记录',
      },
    ],
  },
  {
    key: 'ssry',
    path: '/page/ssry',
    name: '试试如意',
    icon: 'bar-chart',
    sub: [
      {
        key: 'userInfo',
        path: '/page/ssry/userInfo',
        name: '用户信息',
      },
      {
        key: 'recommendGoods',
        path: '/page/ssry/recommendGoods',
        name: '推荐专区',
      },
      {
        key: 'vipRecord',
        path: '/page/ssry/vipRecord',
        name: '会员购买记录',
      },
      {
        key: 'grantRecord',
        path: '/page/ssry/grantRecord',
        name: '派样记录',
      },
      {
        key: 'bankRecord',
        path: '/page/ssry/bankRecord',
        name: '办卡记录',
      },
      {
        key: 'activityCenter',
        path: '/page/ssry/activityCenter',
        name: '种草活动中心',
      },
      {
        key: 'smallProgramSet',
        path: '/page/ssry/smallProgramSet',
        name: '小程序自定义',
      },
      {
        key: 'rules',
        path: '/page/ssry/rules',
        name: '规则设置',
      },
      {
        key: 'manual',
        path: '/page/ssry/manual',
        name: '人工处理',
      },
    ],
  },
  {
    key: 'version',
    path: '/page/version/versionmanagement',
    name: '版本管理',
    icon: 'gold',
  },
]
